export class IncreaseLevel {
  expRequired!: number;
  currentFighterExp!: number;
  advancements!: Advancement[];
}

export class Advancement {
  id!: string;
  name!: string;
  cost!: number;
}